<template>
  <div id="vrTestResultDetails">
    <div>
      <h5 class="mb-3">VR空間ナビ測定詳細</h5>
      <p v-if="vrTestResultDetail === null">
        測定履歴はありません。
      </p>
      <div v-else>
        <b-table responsive :items="vrTestResultDetailArray" :fields="fields">
        </b-table>
        <div class="table-responsive">
          <table class="table table-bordered">
            <tr>
              <td rowspan="3" class="text-center align-middle">
                テストA結果<br>エラーディスタンス
              </td>
              <td class="text-center align-middle">
                <ul class="list-unstyled mb-0">
                  <li v-for="(distance, index) in errorDistances" v-bind:key="distance.id">
                    <ul class="list-inline">
                      <li class="list-inline-item badge badge-light">
                        {{index + 1}}回目
                      </li>
                      <li class="list-inline-item">{{distance}} vm</li>
                    </ul>
                  </li>
                </ul>
              </td>
              <td class="text-center align-middle">
                <ul class="list-inline mb-0">
                  <li class="list-inline-item badge badge-light">
                    平均距離
                  </li>
                  <li class="list-inline-item">
                    {{this.averageErrorDistance}} vm
                  </li>
                </ul>
              </td>
            </tr>
            <tr v-if="relativePositionInAgeIsNotNull">
              <td colspan="2" class="text-center align-middle">
                <ul class="list-inline mb-0">
                  <li class="list-inline-item badge badge-light">
                    同年代評価
                  </li>
                  <li class="list-inline-item">
                    {{this.vrTestResultDetail.relative_position_in_age}}
                  </li>
                </ul>
              </td>
            </tr>
            <tr v-if="relativePositionInAgeIsNotNull">
              <!-- 推定脳健康年齢は計算に年齢を用いておらずnullが渡されることはないため、表示有無の判断には同年代評価を用いる -->
              <td colspan="2" class="text-center align-middle">
                <ul class="list-inline mb-0">
                  <li class="list-inline-item badge badge-light">
                    推定脳健康年齢
                  </li>
                  <li class="list-inline-item">
                    {{this.vrTestResultDetail.estimated_age}}
                  </li>
                </ul>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment-timezone";
  import {GET_VR_TEST_RESULT_DETAIL} from "@/store/actions.type";
  export default {
    name: 'vrTestResultDetails',
    data() {
      return {
        fields: [
          {
            key: "index_num",
            label: "回数"
          },
          {
            key: "created_at",
            label: "日付"
          },
          {
            key: "brain_function_status",
            label: "判定"
          }
        ],
        vrTestResultDetail: null,
        isloading: false
      }
    },
    computed: {
      vrTestResultDetailArray: function () {
        let array = [];
        array.push(this.vrTestResultDetail);
        return array
      },
      errorDistances: function () {
        let array = this.vrTestResultDetail.error_distances;
        return array.map(x => Math.round(x * 1000) / 1000);
      },
      averageErrorDistance: function () {
        return Math.round(this.vrTestResultDetail.average_error_distance * 1000) / 1000
      },
      errorScores: function () {
        let array = this.vrTestResultDetail.error_scores;
        return array.map(x => Math.round(x * 1000) / 1000);
      },
      bestErrorScore: function () {
        return Math.round(this.vrTestResultDetail.best_error_score * 1000) / 1000
      },
      relativePositionInAgeIsNotNull: function () {
        return this.vrTestResultDetail.relative_position_in_age !== null;
      }
    },
    methods: {
      getVrTestResultDetailFromApi() {
        this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });
        this.params = this.$route.params;
        this.$store.dispatch(GET_VR_TEST_RESULT_DETAIL, {
          patientId: this.params.patientId,
          vrTestResultId: this.params.vrTestResultId
        })
        .then(response => {
          this.isLoading.hide();
          this.vrTestResultDetail = response.data;
          this.vrTestResultDetail.created_at = moment.utc(this.vrTestResultDetail.created_at).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm")
          this.vrTestResultDetail.index_num = this.$route.query.index;
        })
      }
    },
    created() {
      this.getVrTestResultDetailFromApi()
    }
  }
</script>
